import { formatAsCurrency, formatAsNumber } from '../utils.js';

class StatsView {
  constructor() {
    this._parentEl = document.querySelector('#stats');
  }

  render(data) {
    const { current, goal, backers, days } = data;

    // 1) Clear parent container
    this._parentEl.innerHTML = '';

    // 2) Create markup
    const markup = `
      <div class="stats__group">
        <span class="stats__number">${formatAsCurrency(current)}</span>
        <span class="stats__label">of ${formatAsCurrency(goal)} backed</span>
      </div>

      <div class="stats__group">
        <span class="stats__number">${formatAsNumber(backers)}</span>
        <span class="stats__label">total backers</span>
      </div>

      <div class="stats__group">
        <span class="stats__number">${days}</span>
        <span class="stats__label">days left</span>
      </div>

      <progress class="stats__progress" max="${goal}" value="${current}"></progress>
    `;

    // 3) Add elements to the DOM
    this._parentEl.insertAdjacentHTML('afterbegin', markup);
  }
}

export default new StatsView();
